// How long a check takes to notice an outage, by check interval. The bars are scaled
// to the 5-minute worst case.
const detectionTimes = [
  { label: '5-minute checks', note: 'Most other free plans', time: '4:59', seconds: 299, bar: 'bg-status-down', text: 'text-status-down' },
  { label: '1-minute checks', note: 'Best paid plans, usually $10+/mo', time: '0:59', seconds: 59, bar: 'bg-status-degraded', text: 'text-status-degraded' },
  { label: '30-second checks', note: 'Uptrack, every plan and monitor', time: '0:29', seconds: 29, bar: 'bg-status-up', text: 'text-status-up' },
]

export function DetectionBars() {
  return (
    <>
        <p className="mb-4 text-sm text-muted-foreground">Worst-case time before a check notices an outage.</p>
        <ul className="space-y-6">
          {detectionTimes.map((d) => (
            <li key={d.label}>
              <div className="mb-2 flex items-baseline justify-between gap-4">
                <span className="text-[15px] font-medium text-foreground">
                  {d.label} <span className="font-normal text-muted-foreground">· {d.note}</span>
                </span>
                <span className={`num text-xl font-semibold ${d.text}`}>{d.time}</span>
              </div>
              <div className="h-2.5 rounded-sm bg-muted">
                <div className={`h-2.5 rounded-sm ${d.bar}`} style={{ width: `${(d.seconds / 299) * 100}%` }} />
              </div>
            </li>
          ))}
        </ul>
        <p className="mt-7 text-[15px] text-body">
          10x faster than the average free plan elsewhere. That is the difference between catching an outage during checkout
          and losing a customer.
        </p>
    </>
  )
}
